import { render, staticRenderFns } from "./IrrigationInstructions.vue?vue&type=template&id=3fad6a58&scoped=true&"
import script from "./IrrigationInstructions.vue?vue&type=script&lang=js&"
export * from "./IrrigationInstructions.vue?vue&type=script&lang=js&"
import style0 from "./IrrigationInstructions.vue?vue&type=style&index=0&id=3fad6a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fad6a58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/abimelec/repositories/nxtagro_op_front/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDataTable,VDialog,VFlex,VLayout,VSelect,VTextarea})
